import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Divider, Header, Menu, Icon, Button } from "semantic-ui-react";
import EventTimer from "./EventTimer";

import request from "../../utils/request";
import { AppContext } from "../../utils/context";

class EventStats extends Component {
  _mounted = false;
  constructor(props, context) {
    super(props);
    this.state = {
      loading: true,
      summary: {},
      pollInterval: false,
      mobileNav: 'collapse'
    };
  }
  componentDidMount = () => {
    this._mounted = true;
    if (this.props.event.id > 0) this.pollData();
  };
  componentDidUpdate = prevProps => {
    if (prevProps.event !== this.props.event) {
      this.pollData();
    }
  };
  componentWillUnmount = () => {
    this._mounted = true;
    clearInterval(this.state.pollInterval);
  };
  startLoading = () => {
    this.setState({ loading: true });
  };
  doneLoading = () => {
    this.setState({ loading: false });
  };
  pollData = () => {
    let self = this;
    self.startLoading();

    return request
      .get(this, `api:/event/${this.props.event.id}`)
      .then(resp => {
        if (!this._mounted) return false;
        self.setState({
          event: resp
        });
        return resp;
      })
      .then(event => {
        request
          .get(this, `api:/event/${event.id}/summary`)
          .then(eventSummary => {
            if (!this._mounted) return false;
            self.setState({
              summary: eventSummary
            }, self.doneLoading);
            return eventSummary;
          }).then(event => {
            self.handlePoll(event);
            return true;
          });
        return event;
      })
  };
  handlePoll = resp => {
    if (!this._mounted) return false;
    if (resp.is_active === true) {
      if (!this.state.pollInterval) {
        let poll = setInterval(this.pollData, 15000);
        this.setState({
          pollInterval: poll
        });
      }
    }
  };
  handleClick = () => {
    const toggleNav = this.state.mobileNav === 'collapse' ? '' : 'collapse';
    this.setState({ mobileNav: toggleNav })
  };

  handleChange = () => {
    this.setState({ mobileNav: 'collapse' });
  };

  render() {
    const { route, eventId, event, pause, startStopShopify } = this.props;
    const { loading, summary, mobileNav } = this.state;
    let tabWidths = 9;
    if (this.context && +this.context.settings.hidden.cash_drops_enabled > 0) tabWidths = tabWidths + 1;
    if (this.context && this.context.settings.option_backend_type === 'bep') tabWidths = tabWidths + 1;
    return (
      <Container fluid style={{ top: '54px', left: '0px', zIndex: '5', background: '#fff' }}>
        <EventTimer event={event} summary={summary} pause={pause} startStopShopify={startStopShopify} />
        <Button
          id="btnNav"
          onClick={this.handleClick}
          fluid
          className={mobileNav === 'collapse' ? 'basic' : ''}>
          <Icon name="bars" />
          {mobileNav === 'collapse' ? 'Expand' : 'Collapse'} Navigation
          </Button>
        <Menu stackable widths={tabWidths} pointing id="eventMenu" color="red" className={mobileNav}>
          <Menu.Item
            active={route.params.action === "summary"}
            as={Link}
            to={"/events/" + eventId + "/summary"}
            onClick={this.handleChange}
          >
            <Header as="h4" icon color={loading ? "grey" : "black"}>
              <Icon name="line chart" fitted />
              <Header.Content>Summary</Header.Content>
            </Header>
          </Menu.Item>
          <Menu.Item
            active={route.params.action === "sellers"}
            as={Link}
            to={"/events/" + eventId + "/sellers"}
            onClick={this.handleChange}
          >
            <Header as="h4" icon color={loading ? "grey" : "black"}>
              {summary.devices ? (
                <Header.Content>{summary.devices.active}</Header.Content>
              ) : (
                  <Icon name="users" fitted />
                )}
              <Header.Content>Seller(s)</Header.Content>
            </Header>
          </Menu.Item>
          <Menu.Item
            active={route.params.action === "devices"}
            as={Link}
            to={"/events/" + eventId + "/devices"}
            onClick={this.handleChange}
          >
            <Header as="h4" icon color={loading ? "grey" : "black"}>
              {summary.devices ? (
                <Header.Content>
                  {(
                    (summary.devices.active / summary.devices.total) *
                    100
                  ).toFixed(0) + "%"}
                </Header.Content>
              ) : (
                  <Icon name="tablet" fitted />
                )}
              <Header.Content>Device Use</Header.Content>
            </Header>
          </Menu.Item>
          <Menu.Item
            active={route.params.action === "messages"}
            as={Link}
            to={"/events/" + eventId + "/messages"}
            onClick={this.handleChange}
          >
            <Header as="h4" icon color={loading ? "grey" : summary.messages && summary.messages.unread > 0 ? "red" : "black"}>
              {summary.messages ? (
                <Header.Content>{summary.messages.unread}</Header.Content>
              ) : (
                  <Icon name="envelope" fitted />
                )}
              <Header.Content>Message(s)</Header.Content>
            </Header>
          </Menu.Item>
          <Menu.Item
            active={route.params.action === "import"}
            as={Link}
            to={"/events/" + eventId + "/import"}
            onClick={this.handleChange}
          >
            <Header as="h4" icon color={loading ? "grey" : "black"}>
              <Icon name="upload" fitted />
              <Header.Content>Tablet Import</Header.Content>
            </Header>
          </Menu.Item>
          <Menu.Item
            active={route.params.action === "winners"}
            as={Link}
            to={"/events/" + eventId + "/winners"}
            onClick={this.handleChange}
          >
            <Header as="h4" icon color={loading ? "grey" : "black"}>
              <Icon name="trophy" fitted />
              <Header.Content>Winners</Header.Content>
            </Header>
          </Menu.Item>
          <Menu.Item
            active={route.params.action === "payments"}
            as={Link}
            to={"/events/" + eventId + "/payments"}
            onClick={this.handleChange}
          >
            <Header as="h4" icon color={loading ? "grey" : "black"}>
              {summary.sales && summary.sales.net ? (
                <Header.Content>${summary.sales.net}</Header.Content>
              ) : (
                <Icon name="dollar sign" fitted />
              )}
              <Header.Content>Payments</Header.Content>
            </Header>
          </Menu.Item>
          {this.context && this.context.settings && this.context.settings.option_backend_type === 'bep' &&
              <Menu.Item
                active={route.params.action === "reprint"}
                as={Link}
                to={"/events/" + eventId + "/reprint"}
                onClick={this.handleChange}
              >
                <Header as="h4" icon color={loading ? "grey" : "black"}>
                  {summary.tickets && summary.tickets.reprints ? (
                    <Header.Content>{summary.tickets.reprints}</Header.Content>
                  ) : (
                    <Icon name="print" fitted />
                  )}
                  <Header.Content>Reprints</Header.Content>
                </Header>
              </Menu.Item>
            }
          {this.context && this.context.settings && +this.context.settings.hidden.cash_drops_enabled > 0 &&
            <Menu.Item
              active={route.params.action === "cashdrops"}
              as={Link}
              to={"/events/" + eventId + "/cashdrops"}
              onClick={this.handleChange}
            >
              <Header as="h4" icon color={loading ? "grey" : "black"}>
                <Icon name="money" fitted />
                <Header.Content>Cash Drops</Header.Content>
              </Header>
            </Menu.Item>
          }
          <Menu.Item
            active={route.params.action === "voids"}
            as={Link}
            to={"/events/" + eventId + "/voids"}
            onClick={this.handleChange}
          >
            <Header as="h4" icon color={loading ? "grey" : summary.voids && summary.voids.new > 0 ? "red" : "black"}>
              {summary.voids ? (
                <Header.Content>{summary.voids.new}</Header.Content>
              ) : (
                  <Icon name="ban" fitted />
                )}
              <Header.Content>Void Request(s)</Header.Content>
            </Header>
          </Menu.Item>
          <Menu.Item
            active={route.params.action === "contributions"}
            as={Link}
            to={"/events/" + eventId + "/contributions"}
            onClick={this.handleChange}
          >
            <Header as="h4" icon color={loading ? "grey" : "black"}>
              {summary.jackpot ? (
                <Header.Content>{`$${summary.jackpot.contributions}`}</Header.Content>
              ) : (
                  <Icon name="gift" fitted />
                )}
              <Header.Content>Contribution(s)</Header.Content>
            </Header>
          </Menu.Item>
        </Menu>
        <Divider hidden />
      </Container>
    );
  }
}

EventStats.contextType = AppContext;

export default EventStats;
